/**
 * Build side pots from per-seat total contributions this hand (all players who put chips in).
 * @param {Array<{ seat: number, totalBet: number, folded: boolean }>} rows
 * @returns {Array<{ amount: number, eligibleSeats: number[] }>}
 */
export function buildSidePots(rows) {
  const active = rows.filter((r) => r.totalBet > 0);
  if (active.length === 0) return [];

  const levels = [...new Set(active.map((r) => r.totalBet))].sort((a, b) => a - b);
  const pots = [];
  let prev = 0;

  for (const level of levels) {
    const increment = level - prev;
    if (increment <= 0) {
      prev = level;
      continue;
    }
    const contributors = active.filter((r) => r.totalBet >= level);
    const amount = increment * contributors.length;
    const eligibleSeats = contributors.filter((r) => !r.folded).map((r) => r.seat);
    if (amount > 0) {
      pots.push({ amount, eligibleSeats });
    }
    prev = level;
  }

  return pots;
}

/**
 * Split `amount` evenly across `winners` (integer chips); remainder to lowest seat index first.
 * @param {number} amount
 * @param {number[]} winners sorted by seat
 * @returns {Map<number, number>}
 */
export function splitPot(amount, winners) {
  const out = new Map();
  if (winners.length === 0 || amount <= 0) return out;
  const base = Math.floor(amount / winners.length);
  let rem = amount - base * winners.length;
  const sorted = [...winners].sort((a, b) => a - b);
  for (const s of sorted) {
    out.set(s, base + (rem > 0 ? 1 : 0));
    if (rem > 0) rem -= 1;
  }
  return out;
}
